import { type PageComponentProps } from '@typings/components/page'

import { Column } from '@components/ui-core/column/column'
import { HeaderType } from '@components/ui-core/header/header'
import { Row } from '@components/ui-core/row/row'

import { PageLayout } from '@custom/components/page-layout/page-layout'

const CustomExPage = ({ data, isPreview }: PageComponentProps) => {
  return (
    <PageLayout data={data} headerType={HeaderType.Global} withFooter>
      <Row gap="16x" crossAxisAlignment="center" mainAxisAlignment="center">
        <Column>
          <h1>✅ Custom Page Example - Registry Component</h1>
          {isPreview && <p>🔍 Preview Mode Active</p>}
          <p>This content is rendered from: src/custom/pages/custom-page-example/page.tsx</p>
        </Column>
      </Row>
    </PageLayout>
  )
}

export default CustomExPage
